import { ElSlider as V } from "element-plus";
import "element-plus/es/components/slider/style/css";
import { createI18n as w } from "vue-i18n";
import a from "lodash/get";
import { resolveComponent as N, openBlock as o, createElementBlock as m, normalizeClass as x, createVNode as T, createElementVNode as h, createCommentVNode as p, toDisplayString as v, withDirectives as b, withKeys as E, vModelText as S } from "vue";
const _ = {
  PtSliderRange: {
    invalidTip: "无效数据或超出数据范围"
  }
}, k = {
  PtSliderRange: {
    invalidTip: "Invalid data or out of data range"
  }
}, R = {
  PtSliderRange: {
    invalidTip: "無効なデータまたはデータ範囲外"
  }
}, B = {
  PtSliderRange: {
    invalidTip: "無效數據或超出數據范圍"
  }
}, P = (n, e) => {
  const s = n.__vccOpts || n;
  for (const [i, t] of e)
    s[i] = t;
  return s;
}, L = 9, c = "min", y = "max", C = {
  name: "PtSliderRange",
  i18n: w({
    messages: {
      cn: _,
      en: k,
      jp: R,
      tw: B
    }
  }),
  components: {
    ElSlider: V
  },
  props: {
    modelValue: {
      type: Array,
      required: !0,
      default: () => []
    },
    /**
     * 节点和真实值的映射关系
     */
    mapList: {
      type: Array,
      required: !0,
      default: () => []
    },
    /**
     * 在水平或者在垂直方向显示输入框
     */
    layoutIsHorizontal: {
      type: Boolean,
      default: !1
    },
    /**
     * 数量单位
     */
    unit: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showTooltip: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      typeIsMin: c,
      typeIsMax: y,
      value: [],
      minInput: "",
      minInputErrorMsg: "",
      maxInput: "",
      maxInputErrorMsg: ""
    };
  },
  computed: {
    invalidText() {
      return this.$t("PtSliderRange.invalidTip");
    },
    max() {
      return this.mapList.length - 1;
    },
    maxPlaceholder() {
      const n = this.mapList[this.mapList.length - 1];
      return (n == null ? void 0 : n.label) || (n == null ? void 0 : n.value);
    }
  },
  watch: {
    modelValue(n) {
      this.init(n);
    },
    disabled() {
      this.init(this.modelValue);
    }
  },
  created() {
    this.init(this.modelValue);
  },
  methods: {
    init(n) {
      const {
        range: e = [],
        minInput: s = "",
        maxInput: i = ""
      } = this.getConfig(n);
      this.value = e, this.minInput = s, this.maxInput = i, this.minInputErrorMsg = "", this.maxInputErrorMsg = "";
    },
    // eslint-disable-next-line consistent-return
    showUnit(n) {
      if (!this.unit)
        return !1;
      if (n === c)
        return String(Number(this.minInput)) !== "0";
      if (n === y)
        return this.maxInput !== "" && String(Number(this.maxInput)) !== "0";
    },
    getInputValue(n) {
      const e = a(this.mapList, `[${n}].value`);
      return e === "*" ? "" : e;
    },
    limitInput(n) {
      let e, s;
      n === c ? (e = "minInput", s = "minInputErrorMsg") : (e = "maxInput", s = "maxInputErrorMsg");
      let i = String(this[e]);
      i = i.replace(/[\D]/g, ""), i.length > L && (i = i.slice(0, L)), this[e] = i, this[s] = "";
    },
    updateRange(n) {
      this.blur();
      const e = this.mapList[this.mapList.length - 1].value, s = parseInt(this.mapList[0].value, 10), i = e === "*" ? 1 / 0 : parseInt(e, 10), t = this.minInput === "" ? -1 : parseInt(this.minInput, 10), l = this.maxInput === "" ? 1 / 0 : parseInt(this.maxInput, 10);
      let u = !0;
      if ((t === -1 || t < s || t >= l || t >= i) && (u = !1, n === c && (this.minInputErrorMsg = this.invalidText)), (i !== 1 / 0 && (l < s || l <= t || l > i) || i === 1 / 0 && (l < s || l <= t)) && (u = !1, n === y && (this.maxInputErrorMsg = this.invalidText)), !u)
        return;
      this.minInputErrorMsg = "", this.maxInputErrorMsg = "";
      const r = [
        String(Number(this.minInput)),
        this.maxInput === "" ? "*" : String(Number(this.maxInput))
      ];
      this.$emit("update:modelValue", r);
    },
    // defaultRange: 真实数值
    getConfig(n) {
      var l, u;
      let e, s, i, t;
      if (typeof n > "u" || n.length === 0)
        e = 0, s = this.mapList.length - 1, i = ((l = this.mapList[e]) == null ? void 0 : l.value) || 0, t = ((u = this.mapList[s]) == null ? void 0 : u.value) || 0;
      else {
        i = parseInt(n[0], 10), t = n[1] === "*" ? "*" : parseInt(n[1], 10);
        const r = (this.mapList || []).map((I) => I.value === "*" ? "*" : parseInt(I.value, 10)), d = parseInt(a(r, r.length - 2), 10);
        let f;
        i > d && r[r.length - 1] === "*" ? f = d : f = r.includes(i) ? i : [...r].sort((I, M) => Math.abs(I - i) - Math.abs(M - i))[0], e = r.indexOf(f);
        let g;
        t === "*" ? g = t : r.length === 2 ? [, g] = r : t > d && r[r.length - 1] === "*" ? g = d : g = r.includes(t) ? t : [...r].sort((I, M) => Math.abs(I - t) - Math.abs(M - t))[0], s = r.indexOf(g);
      }
      return {
        range: [e, s],
        minInput: String(i),
        maxInput: t === "*" ? "" : String(t)
      };
    },
    blur() {
      this.$refs.inputMax.blur(), this.$refs.inputMin.blur();
    },
    inputChangeRange(n) {
      this.blur();
      const e = a(n, "[0]", 0), s = a(n, "[1]", 0), i = String(a(this.mapList, `[${e}].value`)), t = String(a(this.mapList, `[${s}].value`)), l = a(this.value, "[0]", 0), u = a(this.value, "[1]", 0), r = String(a(this.mapList, `[${l}].value`)), d = String(a(this.mapList, `[${u}].value`));
      i !== t && (i !== r || t !== d) && (this.init([i, t]), this.$emit("update:modelValue", [i, t]));
    }
  }
}, U = {
  key: 0,
  class: "disable-bg"
}, z = {
  key: 1,
  class: "error-msg"
}, H = {
  key: 2,
  class: "number-unit"
}, K = {
  key: 0,
  class: "disable-bg"
}, O = {
  key: 1,
  class: "error-msg"
}, q = ["placeholder"], A = {
  key: 2,
  class: "number-unit"
};
function j(n, e, s, i, t, l) {
  const u = N("ElSlider");
  return o(), m("div", {
    class: x(["patsnap-biz-slider_range ai-common-slider-range", [
      s.layoutIsHorizontal ? "layout-is-horizontal" : "layout-is-vertical",
      t.minInputErrorMsg || t.maxInputErrorMsg ? "has-error" : ""
    ]])
  }, [
    T(u, {
      ref: "ElSlider",
      value: t.value,
      max: l.max,
      min: 0,
      range: !0,
      disabled: s.disabled,
      "show-tooltip": s.showTooltip,
      onInput: l.inputChangeRange
    }, null, 8, ["value", "max", "disabled", "show-tooltip", "onInput"]),
    h("div", {
      class: x(["range-input min", { "is-error": t.minInputErrorMsg, "show-unit": l.showUnit(t.typeIsMin) }])
    }, [
      s.disabled ? (o(), m("div", U)) : p("", !0),
      t.minInputErrorMsg ? (o(), m("div", z, [
        h("p", null, v(t.minInputErrorMsg), 1)
      ])) : p("", !0),
      b(h("input", {
        ref: "inputMin",
        "onUpdate:modelValue": e[0] || (e[0] = (r) => t.minInput = r),
        type: "text",
        onInput: e[1] || (e[1] = (r) => l.limitInput(t.typeIsMin)),
        onKeyup: e[2] || (e[2] = E((r) => l.updateRange(t.typeIsMin), ["enter"])),
        onBlur: e[3] || (e[3] = (r) => l.updateRange(t.typeIsMin))
      }, null, 544), [
        [S, t.minInput]
      ]),
      l.showUnit(t.typeIsMin) ? (o(), m("div", H, v(s.unit), 1)) : p("", !0)
    ], 2),
    s.layoutIsHorizontal ? p("", !0) : (o(), m("div", {
      key: 0,
      class: x(["range-input-line", { disabled: s.disabled }])
    }, " - ", 2)),
    h("div", {
      class: x(["range-input max", { "is-error": t.maxInputErrorMsg, "show-unit": l.showUnit(t.typeIsMax) }])
    }, [
      s.disabled ? (o(), m("div", K)) : p("", !0),
      t.maxInputErrorMsg ? (o(), m("div", O, [
        h("p", null, v(t.maxInputErrorMsg), 1)
      ])) : p("", !0),
      b(h("input", {
        ref: "inputMax",
        "onUpdate:modelValue": e[4] || (e[4] = (r) => t.maxInput = r),
        type: "text",
        placeholder: l.maxPlaceholder,
        onInput: e[5] || (e[5] = (r) => l.limitInput(t.typeIsMax)),
        onKeyup: e[6] || (e[6] = E((r) => l.updateRange(t.typeIsMax), ["enter"])),
        onBlur: e[7] || (e[7] = (r) => l.updateRange(t.typeIsMax))
      }, null, 40, q), [
        [S, t.maxInput]
      ]),
      l.showUnit(t.typeIsMax) ? (o(), m("div", A, v(s.unit), 1)) : p("", !0)
    ], 2)
  ], 2);
}
const W = /* @__PURE__ */ P(C, [["render", j]]);
export {
  W as default
};
